export default "__VITE_ASSET__aRmgUsx1__"